<script>
export default {
  props: {
    options: Object
  },
  data: function() {
    return {
      data: [],
      nextPageUrl: null,
      infiniteId: +new Date()
    };
  },
  methods: {
    onFilterData: function(event) {
      this.nextPageUrl = null;
      this.data = [];
      this.infiniteId += 1;
    },
    onLoadMore: function($state) {
      var vm = this,
        url = this.nextPageUrl;

      if (!url) {
        url = API_URL + this.options.endpoint;
      }

      this.axios
        .get(url, {
          params: {
            categoria: this.options.categoria
          }
        })
        .then(response => {
          if (response.data.data) {
            this.data.push(...response.data.data);
          }

          this.nextPageUrl = response.data.next_page_url;

          if (this.nextPageUrl) {
            console.log(this.nextPageUrl);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    }
  }
};
</script>